<template>
  <div
    :class="[
      stacked
        ? 'inline-flex flex-col-reverse items-start gap-y-px'
        : 'inline-flex items-center gap-x-2',
      disabled && 'cursor-not-allowed',
    ]"
  >
    <input
      type="checkbox"
      :checked="toggleValue"
      :disabled="disabled"
      class="z-0 mb-0 block"
      @input="setValue(!toggleValue)"
    />
    <label
      v-if="label || help || $slots.default"
      class="mb-0 block"
      :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
      @click="setValue(!toggleValue)"
    >
      <span :class="labelClass" class="mt-px items-center leading-none">
        {{ label ? label.charAt(0).toUpperCase() + label.slice(1) : '' }}
      </span>
    </label>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    help: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: 'whitespace-no-wrap',
    },
    rerenderEarly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'will-change', 'change'],
  setup(props, { emit }) {
    const toggleValue = ref(props.value)

    watch(
      () => props.value,
      value => {
        toggleValue.value = value
      }
    )

    function setValue(value) {
      if (props.disabled) {
        return
      }
      if (toggleValue.value === value) {
        return
      }

      toggleValue.value = value

      if (props.rerenderEarly) {
        emit('will-change', value)

        requestAnimationFrame(() => {
          setTimeout(() => {
            emit('input', value)
            emit('change', value)
          }, 0)
        })
      } else {
        emit('input', value)
        emit('change', value)
      }
    }

    return { toggleValue, setValue }
  },
}
</script>
